let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hNfx0")).then(() => parcelRequire('dzYyj'));